import {
  ScheduleValidationData,
  Phase,
  ValidationResult
} from 'modules/Cube/domain/cube.domain.types'

export const noIncompatiblePriceProration =
  (ctx: { phaseId: Phase['id'] }) =>
  (prevState: ScheduleValidationData): ValidationResult[] | null => {
    const thisPhase = prevState.queries.resolvedPhases[ctx.phaseId]

    if (thisPhase.analysis?.proration.invalidPrices.length) {
      return [
        {
          message:
            'A quote phase contains prices which are updated in the middle of a billing period.',
          metadata: {
            invalidPrices: thisPhase.analysis?.proration.invalidPrices
          }
        }
      ]
    }

    return null
  }
